import React from 'react';
import { Select } from 'components/select';
import { ITabItem, TabItem } from './tab-item/tab-item';
import styles from './tab-filter.module.scss';

interface IProps {
	title: string;
	tabItems: ITabItem[];
	selectedTabItem?: ITabItem;
	onChange: (tabItem: ITabItem) => void;
}

export const TabFilter = (props: IProps): React.JSX.Element => {
	const onTabChange = (tabItem: ITabItem): void => {
		props.onChange(tabItem);
	};

	const onSelectChange = (event: React.ChangeEvent<HTMLSelectElement>): void => {
		const tabItem = props.tabItems.find((item) => item.id === event.target.value) || props.tabItems[0];
		props.onChange(tabItem);
	};

	return (
		<>
			<ul className={styles.tabs}>
				{props.tabItems.map((tabItem) => (
					<TabItem
						selectedTabItem={props.selectedTabItem}
						key={tabItem.id}
						tabItem={tabItem}
						onChange={onTabChange}
						aria-controls="pageResults"
					/>
				))}
			</ul>

			<Select
				title={props.title}
				className={styles.dropdown}
				options={props.tabItems}
				value={props.selectedTabItem?.id}
				onChange={onSelectChange}
				fullWidth
			/>
		</>
	);
};
